export default "__VITE_ASSET__BuRbYM_J__"